import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description?: string;
  canonical?: string;
  image?: string;
  type?: "website" | "article" | "product";
  jsonLd?: Record<string, any> | Record<string, any>[];
  noindex?: boolean;
}

const DEFAULT_DESCRIPTION =
  "Book sauna, cold plunge, and recovery sessions at top wellness studios near you. Instant booking and seamless check-in with Wellsuites.";
const DEFAULT_IMAGE = "https://wellsuites.co/og-image.jpg";
const SITE_URL = "https://wellsuites.co";

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  noindex = false,
}: SEOProps) => {
  const url =
    canonical ||
    (typeof window !== "undefined" ? window.location.href : SITE_URL);
  // Truncate description to ~160 chars for SEO best practice
  const desc = description.length > 160 ? description.slice(0, 157) + "..." : description;
  const fullTitle = title.length > 60 ? title.slice(0, 57) + "..." : title;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd])}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
